import { Link, NumberedMilestones, Text, TextContainer } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "@wayflyer/undercarriage";

import { MESSAGES } from "./message-definitions";

export const HowItWorks = () => {
  const intl = useIntl();

  const {
    data: { customerDomain },
  } = useCustomerAppConfig();

  return (
    <NumberedMilestones
      milestones={[
        {
          number: "01",
          title: intl.formatMessage(MESSAGES.faqSubmitNewFundingApplicationHeader),
          body: (
            <TextContainer>
              {intl.formatMessage(MESSAGES.faqSubmitNewFundingApplicationBody, {
                p: (chunks: any) => <Text>{chunks}</Text>,
              })}
            </TextContainer>
          ),
        },
        {
          number: "02",
          title: intl.formatMessage(MESSAGES.faqReviewDataHeader),
          body: (
            <TextContainer>
              {intl.formatMessage(MESSAGES.faqReviewDatabody, {
                p: (chunks: any) => <Text>{chunks}</Text>,
                x: (chunks: any) => <Link url={`/${customerDomain}/settings/company/connections`}>{chunks}</Link>,
              })}
            </TextContainer>
          ),
        },
        {
          number: "03",
          title: intl.formatMessage(MESSAGES.faqReviewAndSelectOffersHeader),
          body: <TextContainer>{intl.formatMessage(MESSAGES.faqReviewAndSelectOffersBody)}</TextContainer>,
        },
        {
          number: "04",
          title: intl.formatMessage(MESSAGES.faqAcceptContractReceiveFundingHeader),
          body: (
            <TextContainer>
              {intl.formatMessage(MESSAGES.faqAcceptContractReceiveFundingBody, {
                p: (chunks: any) => <Text>{chunks}</Text>,
              })}
            </TextContainer>
          ),
        },
      ]}
    />
  );
};
